<div class="icon-cancel" *ngIf="!showGoBack" (click)="closeNavBar()"></div>

<div class="reg_scroll" [ngClass]="isShowScroll ? 'reg-step-two-page-scroll' : ''">
  <div id="left_nav--signup">
    <div class="left_nav--signup_top">
      <div class="left_nav-reg_logo"></div>
      <div class="left_nav--steps">
        <span>{{ stepkey | translate}}</span><span>{{'registrationComp.headerSteps' | translate}}</span>
      </div>
    </div>
    <app-registration-step-one *ngIf="step==='step1'" [fromNavBar]="true" (stepOneOkay)="showStep2()">
    </app-registration-step-one>
    <app-registration-step-two [fromNavBar]="true" *ngIf="step==='step2'"></app-registration-step-two>
  </div>

<div class="reg_goback" *ngIf="showGoBack">
  <div class="reg_goback--container">
    <app-reg-goback (continueRegistration)="continueReg()"></app-reg-goback>
  </div>
</div>